// @ts-nocheck
import { Theme } from '@emotion/react'

import * as variables from './styles/variables.module.scss'

const theme: Theme = {
    colors: {
        success: variables.colorGreen,
        warning: variables.colorYellow,
        error: variables.colorRed,

        primary: variables.colorBluePastel,
        primaryDisabled: variables.colorBlueDull,
        secondary: variables.colorGray,
        secondaryDisabled: variables.colorGrayLightest,
        backgroundGray: variables.colorGrayWhite,
        border: variables.colorGrayLightest,
        hover: variables.colorBlueLight,

        pastelSkyBlue: variables.colorBluePastel,
        pastelDarkBlueViolet: variables.colorBlueVioletDark,

        white: variables.colorWhite,
        borderGray: variables.colorGrayWhite,
        grayLightest: variables.colorGrayLightest,
        grayLight: variables.colorGrayLight,
        textGray: variables.colorGray,
        grayGravel: variables.colorGrayGravel,
        grayOnyx: variables.colorGrayOnyx,
        grayDark: variables.colorGrayDark,
        black: variables.colorBlack,

        red: variables.colorRed,

        yellow: variables.colorYellow,

        green: variables.colorGreen,
        pastelGreen: variables.colorGreenPastel,

        blueDark: variables.colorBlueDark,
        silverSand: variables.colorSilverSand,
    },
    bps: {
        sm: variables.screenSizeSmall,
        md: variables.screenSizeMedium,
        lg: variables.screenSizeLarge,
        xl: variables.screenSizeXL,
    },
    fontSize: {
        xs: variables.fontSizeXS,
        sm: variables.fontSizeSmall,
        md: variables.fontSizeMedium,
        lg: variables.fontSizeLarge,
        xl: variables.fontSizeXL,
    },
    fontFamily: {
        primary: variables.fontFamilyPrimary,
        secondary: variables.fontFamilySecondary,
    },
}

export type { TTheme }
export default theme
